// import React from "react";
// import 'swiper/css';
// import 'swiper/css/navigation';
// import './Home.css';
// import { Link } from "react-router-dom";

// // Import Swiper core and required components
// import { Swiper, SwiperSlide } from 'swiper/react';
// import { Navigation } from 'swiper/modules';
// import ServiceSlider from "../ServiceSlider/ServiceSlider/ServiceSlider";

// const Home = () => {
//   return (
//     <div>
//       <Swiper navigation={true} modules={[Navigation]} className="mySwiper">
//       <SwiperSlide>
//           <div className="slider_bg4">
//           <div className="slider_text_container">
//                 <h3 className="slider_text_heading">Look Sharp<span style={{color:"#e4cc52"}}> Feel Great</span><br/> Royalty</h3>
//                <Link to='/products' className="tf-btn style-2 btn-fill radius-3 animate-hover-btn ">SHOP COLLECTION</Link>
//                 </div>
//           </div>
//         </SwiperSlide>
//         <SwiperSlide>
//           <div className="slider_bg1">
//             <div className="slider_text_container">
//                 <h3 className="slider_text_heading">Royal Looks,<span style={{color:"#e4cc52"}}>Right Here!</span></h3>
//                <Link to='/products' className="tf-btn style-2 btn-fill radius-3 animate-hover-btn ">SHOP COLLECTION</Link>
//                 </div>
//           </div>
//         </SwiperSlide>
//         <SwiperSlide>
//           <div className="slider_bg2">
//           <div className="slider_text_container">
//                 <h3 className="slider_text_heading">Dress Your <span style={{color:"#e4cc52"}}>Best Today</span></h3>
//                <Link to='/products' className="tf-btn style-2 btn-fill radius-3 animate-hover-btn ">SHOP COLLECTION</Link>
//                 </div>
//           </div>
//         </SwiperSlide>
//         <SwiperSlide>
//           <div className="slider_bg3">
//           <div className="slider_text_container_right">
//                 <h3 className="slider_text_heading">Timeless Grace<br/><span style={{color:"#e4cc52"}}>Crafted for</span> royalty</h3>
//                <Link to='/products' className="tf-btn style-2 btn-fill radius-3 animate-hover-btn ">SHOP COLLECTION</Link>
//                 </div>
//           </div>
//         </SwiperSlide>
        

//         <SwiperSlide>
//           <div className="slider_bg5">
//           <div className="slider_text_container">
//                 <h3 className="slider_text_heading">Classic Wear <span style={{color:"#e4cc52"}}>For<br/> Royal Men</span></h3>
//                <Link to='/products' className="tf-btn style-2 btn-fill radius-3 animate-hover-btn ">SHOP COLLECTION</Link>
//                 </div>
//           </div>
//         </SwiperSlide>

//         <SwiperSlide>
//           <div className="slider_bg6">
//           <div className="slider_text_container">
//                 <h3 className="slider_text_heading">Tradition Meets <span style={{color:"#e4cc52"}}>Style</span></h3>
//                <Link to='/products' className="tf-btn style-2 btn-fill radius-3 animate-hover-btn ">SHOP COLLECTION</Link>
//                 </div>
//           </div>
//         </SwiperSlide>

//       </Swiper>
//       <ServiceSlider />
      
//     </div>
//   );
// };

// export default Home;



import React from "react";
// import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/effect-fade'; // Import fade effect styles
import './Home.css';
import { BiCategoryAlt } from "react-icons/bi";
import { IoSearchOutline } from "react-icons/io5";
import { MdOutlineAccountCircle } from "react-icons/md";
import { FaShoppingCart } from "react-icons/fa";
import { IoHome } from "react-icons/io5";
import { Link } from "react-router-dom";
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Autoplay, Pagination, EffectFade } from 'swiper/modules';
import ServiceSlider from "../ServiceSlider/ServiceSlider/ServiceSlider";

const Home = () => {
  return (
    <div>
      <Swiper
        navigation={true}
        autoplay={{
          delay: 2500, // 2.5 seconds delay
          disableOnInteraction: false, // Keeps autoplay running even after interaction
        }}
        pagination={{
          clickable: true, // Dots are clickable
          dynamicBullets: true,
        }}
       
        speed={1000} // Adjust transition speed to 1 second
        modules={[Navigation, Autoplay, Pagination, EffectFade]} // Include EffectFade module
        className="mySwiper"
      >
        <SwiperSlide>
          <div className="slider_bg4">
            <div className="slider_text_container">
              <h3 className="slider_text_heading">Look Sharp<span style={{ color: "#e4cc52" }}> Feel Great</span><br /> Royalty</h3>
              <Link to='/products' className="tf-btn style-2 btn-fill radius-3 animate-hover-btn ">SHOP COLLECTION</Link>
            </div>
          </div>
        </SwiperSlide>
        <SwiperSlide>
          <div className="slider_bg5">
            <div className="slider_text_container">
              <h3 className="slider_text_heading">Classic Wear <span style={{ color: "#e4cc52" }}>For<br /> Royal Men</span></h3>
              <Link to='/products' className="tf-btn style-2 btn-fill radius-3 animate-hover-btn ">SHOP COLLECTION</Link>
            </div>
          </div>
        </SwiperSlide>
    
        <SwiperSlide>
          <div className="slider_bg2">
            <div className="slider_text_container">
              <h3 className="slider_text_heading">Dress Your <span style={{ color: "#e4cc52" }}>Best Today</span></h3>
              <Link to='/products' className="tf-btn style-2 btn-fill radius-3 animate-hover-btn ">SHOP COLLECTION</Link>
            </div>
          </div>
        </SwiperSlide>
        <SwiperSlide>
          <div className="slider_bg3">
            <div className="slider_text_container">
              <h3 className="slider_text_heading">Timeless Grace<br /><span style={{ color: "#e4cc52" }}>Crafted for</span> royalty</h3>
              <Link to='/products' className="tf-btn style-2 btn-fill radius-3 animate-hover-btn ">SHOP COLLECTION</Link>
            </div>
          </div>
        </SwiperSlide>
        <SwiperSlide>
          <div className="slider_bg1">
            <div className="slider_text_container">
              <h3 className="slider_text_heading">Royal Looks,<span style={{ color: "#e4cc52" }}>Right Here!</span></h3>
              <Link to='/products' className="tf-btn style-2 btn-fill radius-3 animate-hover-btn ">SHOP COLLECTION</Link>
            </div>
          </div>
        </SwiperSlide>
        <SwiperSlide>
          <div className="slider_bg6">
            <div className="slider_text_container">
              <h3 className="slider_text_heading">Tradition Meets <span style={{ color: "#e4cc52" }}>Style</span></h3>
              <Link to='/products' className="tf-btn style-2 btn-fill radius-3 animate-hover-btn ">SHOP COLLECTION</Link>
            </div>
          </div>
        </SwiperSlide>
      </Swiper>
      <ServiceSlider />
      <div class="tf-toolbar-bottom type-1150">
        <div class="toolbar-item">
            <a style={{color:"black"}} href="/">
                <div class="toolbar-icon">
                <IoHome />
                </div>
                <div class="toolbar-label">Home</div>
            </a>
        </div>
        <div class="toolbar-item">
            <a style={{color:"black"}} href="/products" >
                <div class="toolbar-icon">
                <BiCategoryAlt />
                </div>
                <div class="toolbar-label">Shop</div>
            </a>
        </div>
        <div class="toolbar-item">
            <a style={{color:"black"}} href="/SearchBar" >
                <div class="toolbar-icon">
                <IoSearchOutline />
                </div>
                <div class="toolbar-label">Search</div>
            </a>
        </div>
        {/* <div class="toolbar-item">
            <a style={{color:"black"}} href="#" >
                <div class="toolbar-icon">
                <MdOutlineAccountCircle />
                </div>
                <div class="toolbar-label">Account</div>
            </a>
        </div> */}

        <div class="toolbar-item">
            <a style={{color:"black"}} href="/cart">
                <div class="toolbar-icon">
                <FaShoppingCart />
                </div>
                <div class="toolbar-label">Cart</div>
            </a>
        </div>
    </div>
    </div>
  );
};

export default Home;
